import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@nextiva/next-ui-components';

export const blockName = 'ui-alert';

const AlertComponent = ({
  applyTimer,
  customMessage,
  customTime,
  onClose,
  severity,
}) => {
  /**
   * Closes the Alert after a period of time.
   */
  const closeAfterTimer = useCallback(() => {
    const timer = setTimeout(() => {
      onClose();
    }, customTime);

    return () => clearTimeout(timer);
  }, [onClose, customTime]);

  useEffect(() => {
    if (applyTimer) {
      closeAfterTimer();
    }
  }, [applyTimer, closeAfterTimer]);

  return (
    <Alert
      className={blockName}
      data-testid={blockName}
      severity={severity}
      onClose={onClose}
    >
      {customMessage}
    </Alert>
  );
};

AlertComponent.defaultProps = {
  applyTimer: true,
  customMessage: 'Succeeded',
  customTime: 5_000,
  severity: 'info',
};

AlertComponent.propTypes = {
  applyTimer: PropTypes.bool,
  customMessage: PropTypes.string,
  customTime: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  severity: PropTypes.string,
};

export default AlertComponent;
